import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import TitleBlock from '../TitleBlock';
import SideItems from '../SideItems/SideItems';


export default function Sidebar(props) {
    const { isOffscreen,  
            autoToggle, 
            projects, 
            setSelectedProject,
            dailies, setDailies,
            illusion, setIllusion,
            assets, setAssets,
            project, setProject,
            settings, setSettings
        } = props

    const handleTransitionEnd = () => {
        // This function will be called when the transition ends.
        // You can perform your desired actions here.
        if (isOffscreen) {
          // The box has finished moving offscreen
          // Add your code here
        } else {
          // The box has finished moving back onscreen
          // Add your code here
        }
      };

      const theme = useTheme();
      const isXs = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <React.Fragment>

            <Box
                elevation={3} // Optional: Add a shadow
                display="flex" 
                flexDirection="column" 
                justifyContent="space-between"
                sx={{ 
                    backgroundColor: isOffscreen ? 'rgba(0, 0, 0, 0)' : 'rgba(0, 0, 0, 1)', 
                    color: 'white', 
                    width: isOffscreen ? '0px' : isXs ? '100%' : '300px',
                    height: '100%', 
                    boxShadow: isOffscreen ? '0px 0px 6px rgba(0, 0, 0, 0.1)' : '2px 0px 6px rgba(0, 0, 0, 0.7)',
                    transition: 'background-color 0.3s ease-out, transform 0.5s ease-out, width 0.5s ease-out',
                    transform: isOffscreen ? 'translateX(-100%)' : 'translateX(0%)',
                    overflow:'hidden'
                    }} 
                onTransitionEnd={handleTransitionEnd}>
                <Box
                    id="sidebar-navigation-items"
                    sx={{
                        flex: 1,
                        overflowY: 'auto'
                    }}>
                    <SideItems 
                        isOffscreen={isOffscreen} 
                        autoToggle={autoToggle} 
                        dailies={dailies} setDailies={setDailies}
                        illusion={illusion} setIllusion={setIllusion}
                        assets={assets} setAssets={setAssets}
                        project={project} setProject={setProject}
                        settings={settings} setSettings={setSettings}
                        />
                </Box>
                <TitleBlock isOffscreen={isOffscreen} projects={projects} setSelectedProject={setSelectedProject} />
            </Box>
        </React.Fragment>
    )
}